import { useQuery } from "@tanstack/react-query";

import axiosInstance from "@/api/axiosInstance";

const getUnreadCountNotify = async () => {
  const response = await axiosInstance.get("api/v1/admin/notifications/unread-count");
  return response.data.data;
};

export const useGetUnreadCountNotify = () => {
  return useQuery({
    queryKey: ["notificationUnreadCount"],
    queryFn: () => getUnreadCountNotify(),
  });
};
